export const environment = {
  production: false,
  env: 'sbx'
};

